<template>
  <v-layout row>
    <v-btn v-if="user && isCommunityOwner" dark fab right color="teal" slot="activator"
           @click="openEditDialog" style="bottom: 30px; right:10px; position: fixed; z-index: 1">
      <v-icon>edit</v-icon>
    </v-btn>

    <v-flex>
      <v-card>
        <v-container>
          <tiptap-editor :content="about" :editable="false"></tiptap-editor>
        </v-container>
      </v-card>
    </v-flex>

    <v-dialog v-model="editFlag" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="editFlag = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Markdown Editor</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout wrap>
            <v-flex xs12 sm6 offset-sm3 class="mt-3">
              <tiptap-editor :content="about" @onBlur="editContent"></tiptap-editor>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn :loading="isAboutSaving" :disabled="isAboutSaving"
                     color="teal white--text" @click="saveAbout()">
                save
                <span slot="loader">Loading...</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import firebase from 'firebase';
import TiptapEditor from '@/components/TiptapEditor.vue';

export default {
  name: 'AboutSpace',
  components: {
    TiptapEditor,
  },
  props: {
    user: Object,
    communityId: String,
    about: String,
    isCommunityOwner: Boolean,
  },
  data() {
    return {
      editFlag: false,
      isAboutSaving: false,
      editAbout: '',
    };
  },
  methods: {
    openEditDialog() {
      this.editAbout = this.about;
      this.editFlag = true;
    },
    editContent(content) {
      this.editAbout = content;
    },
    saveAbout() {
      this.isAboutSaving = true;
      const communityRef = firebase.firestore().collection('communities').doc(this.communityId);
      communityRef.update({ about: this.editAbout })
        .then(() => {
          this.isAboutSaving = false;
          this.$emit('editAbout', this.editAbout);
          this.editFlag = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
  .v-note-wrapper .v-note-panel .v-note-show .v-show-content {
    background: #fff;
  }
  .v-note-wrapper{
    z-index: 0;
  }
</style>
